/**
 * Single article link card for help center listings
 */

import { Link } from 'react-router-dom';
import { ChevronRight, FileText } from 'lucide-react';
import { HelpArticleSummary } from '../../types';

interface HelpArticleCardProps {
  article: HelpArticleSummary;
  showCategory?: boolean;
  categoryName?: string;
}

export function HelpArticleCard({
  article,
  showCategory = false,
  categoryName,
}: HelpArticleCardProps): JSX.Element {
  return (
    <Link
      to={`/help/article/${article.slug}`}
      className="group flex items-start justify-between p-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-primary-300 dark:hover:border-primary-600 hover:shadow-md transition-all"
    >
      <div className="flex items-start gap-3 min-w-0">
        <FileText
          size={18}
          className="text-gray-400 dark:text-gray-500 mt-0.5 flex-shrink-0"
        />
        <div className="min-w-0">
          <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100 group-hover:text-primary-600 dark:group-hover:text-primary-400 truncate">
            {article.title}
          </h3>
          {showCategory && categoryName && (
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
              {categoryName}
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2 flex-shrink-0 ml-2">
        {article.featured && (
          <span className="px-2 py-0.5 text-xs font-medium bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 rounded-full">
            Popular
          </span>
        )}
        <ChevronRight
          size={16}
          className="text-gray-400 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors"
        />
      </div>
    </Link>
  );
}

export default HelpArticleCard;
